import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexComponent',
  setup(__props) {

const UiTable = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/UiTable.vue"))
const AlertComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/AlertComponent.vue"))
const ProgressbarComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/ProgressbarComponent.vue"))
const CheckboxComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/CheckboxComponent.vue"))
const RadioButtons = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/RadioButtons.vue"))
const SelectComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/SelectComponent.vue"))
const InputComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/InputComponent.vue"))
const BadgesComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/BadgesComponent.vue"))
const TootipComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/TootipComponent.vue"))
const SwitchComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/SwitchComponent.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UiTable)),
      _createVNode(_unref(AlertComponent)),
      _createVNode(_unref(ProgressbarComponent)),
      _createVNode(_unref(CheckboxComponent)),
      _createVNode(_unref(RadioButtons)),
      _createVNode(_unref(SelectComponent)),
      _createVNode(_unref(InputComponent)),
      _createVNode(_unref(BadgesComponent)),
      _createVNode(_unref(TootipComponent)),
      _createVNode(_unref(SwitchComponent))
    ])
  ]))
}
}

})